import { useEffect, useState } from "react";

const useCooldown = (lockUntil) => {
  const [cooldownMs, setCooldownMs] = useState(0);

  useEffect(() => {
    if (!lockUntil) {
      setCooldownMs(0);
      return undefined;
    }
    const interval = setInterval(() => {
      const remaining = Math.max(lockUntil - Date.now(), 0);
      setCooldownMs(remaining);
    }, 50);
    return () => clearInterval(interval);
  }, [lockUntil]);

  const isLocked = Boolean(lockUntil) && cooldownMs > 0;

  return { cooldownMs, isLocked };
};

export default useCooldown;
